import axios from './_axios_config';
import { request, buildQuery } from './_process_request';

export const ct_materials = {
    async getMaterials(params) {
        return request(axios.get(`/materials${buildQuery(params)}`));
    },

    async getMaterial(id) {
        return request(axios.get(`/materials/${id}`));
    },

    async createMaterial(data) {
        return request(axios.post('/materials', data));
    },

    async updateMaterial(id, data) {
        return request(axios.put(`/materials/${id}`, data));
    },

    async deleteMaterial(id) {
        return request(axios.delete(`/materials/${id}`));
    },

    async getStock(params) {
        return request(axios.get(`/stock${buildQuery(params)}`));
    },

    // data: { stock, reason } ou { delta, reason }
    async adjustStock(id, data) {
        return request(axios.post(`/materials/${id}/adjust`, data));
    },

    async getAdjustments(id, params) {
        return request(axios.get(`/materials/${id}/adjustments${buildQuery(params)}`));
    },

    async buildPriceTableMessage(data) {
        return request(axios.post('/price-table/message', data));
    },
};
